module.exports = __webpack_public_path__ + "img/business-rules.30243672.gif";